import UserAccountPanel from './UserAccountsPanel';

export default UserAccountPanel;
